import type { SetStateAction } from 'react';

/** Resolves a `useState`-style argument: a value, or an updater of the previous value. */
export const resolveSetStateAction = <Value>(
  update: SetStateAction<Value>,
  previousValue: Value,
): Value =>
  typeof update === 'function'
    ? (update as (previousValue: Value) => Value)(previousValue)
    : update;
